<template>
    <section class="c-login">
        <div class="c-login__body">

            <app-intro>
                <h1>Inloggen</h1>
            </app-intro>

            <login-form />

            <ul class="c-login__list">
                <li class="c-login__item"><router-link class="c-login__link" to="/register">Nieuw account</router-link></li>
                <li class="c-login__item"><router-link class="c-login__link" to="/forgot-password">Wachtwoord vergeten?</router-link></li>
            </ul>

        </div>
    </section>
</template>

<script>
    import AppIntro from '../../components/app/AppIntro.vue';
    import LoginForm from '../../components/forms/LoginForm.vue';

    export default {
        components: { LoginForm, AppIntro },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .c-login {
        display: grid;
        height: 100%;
        -ms-grid-columns: 1fr;

        &__body {
            align-self: center;
            justify-self: center;
            width: 85%;

            @include media-breakpoint-up(md) {
                width: 50%;
            }
        }

        &__list {
            @include zero;
            margin-top: rem(50);
            display: flex;
            list-style: none;
            justify-content: center;
        }

        &__item {
            & + & {
                margin-left: rem(20);
            }
        }

        &__link {
            color: $text-color;
        }
    }
</style>
